namespace RioERP {
    export interface ExcelImportRequest extends Serenity.ServiceRequest {
        FileName?: string;
        ProductId?: number;
        stateId?: number;
        CustomerId?: number;
        InvoiceCompanyId?: number;
        ShippingProviderId?: number;
        SelectedName?: string;
    }
}
